export default "__VITE_ASSET__2c09f630__"